"use strict";

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _my_hash = require("./my_hash.js");

function _readOnlyError(name) {
  throw new TypeError("\"" + name + "\" is read-only");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Libs = function Libs(_rootObj) {
  var _this = this;

  _classCallCheck(this, Libs);

  _defineProperty(this, "add", function (lib) {
    var rootObj = _this.rootObj;
    var libName = lib.libName;
    if (!libName) throw new Error('Lib should have field libName');
    if (!libName.split) throw new Error('libName should be string');

    if (rootObj.libs[libName]) {
      rootObj.libs[libName] = lib;
      return false;
    } else {
      rootObj.libs[libName] = lib;
      return true;
    }
  });

  _defineProperty(this, "remove", function (libOrName) {
    var rootObj = _this.rootObj;
    var libName = libOrName;

    if (!libName.split) {
      libName.libName, _readOnlyError("libName");
      if (!libName) throw new Error('Lib should have field libName');
    }

    if (rootObj.libs[libName]) {
      delete rootObj.libs[libName];
      return true;
    }

    return false;
  });

  _defineProperty(this, "libHash", function () {
    return _my_hash.MY_HASH;
  });

  this.rootObj = _rootObj;
  _rootObj.libs = this;
};

module.exports = Libs;